import { Abilities, Ability } from './interfaces/IAbilityData'
import IAbilityOrigin from './interfaces/IAbilityOrigin'

const origins: Abilities<IAbilityOrigin> = {
  [Ability.math]: IAbilityOrigin.game,
  [Ability.attention]: IAbilityOrigin.game,
  [Ability.executiveFunctions]: IAbilityOrigin.game,
  [Ability.memory]: IAbilityOrigin.game,
  [Ability.motor]: IAbilityOrigin.questionnaire,
  [Ability.social]: IAbilityOrigin.questionnaire,
  [Ability.spatial]: IAbilityOrigin.game,
  [Ability.selfEsteem]: IAbilityOrigin.questionnaire,
  [Ability.language]: IAbilityOrigin.questionnaire
}

export default origins



// WEBPACK FOOTER //
// ./src/data/abitilies/abilityOrigins.ts